import React, { useState } from 'react';
import { Input } from '../ui/Input';
import { Textarea } from '../ui/Textarea';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
const WEB3FORMS_ACCESS_KEY = 'b7789131-e060-4196-aa41-6a4c61a3a4d1';
const WEB3FORMS_ACTION = 'https://api.web3forms.com/submit';
interface DemoRequestFormProps {
  onSuccess?: () => void;
}
export function DemoRequestForm({
  onSuccess
}: DemoRequestFormProps) {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitError(null);
    const formData = new FormData(e.currentTarget);
    const payload: Record<string, string> = {
      access_key: WEB3FORMS_ACCESS_KEY,
      subject: 'Zahtev za demonstraciju - D-TECH Solutions',
      from_name: 'D-TECH sajt - demo zahtev',
      botcheck: ''
    };
    formData.forEach((value, key) => {
      if (typeof value === 'string') payload[key] = value;
    });
    setIsSubmitting(true);
    try {
      const response = await fetch(WEB3FORMS_ACTION, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (response.ok && result.success) {
        setIsSubmitting(false);
        setSubmitSuccess(true);
        if (typeof (window as any).gtag === 'function') {
          ;
          (window as any).gtag('event', 'generate_lead', {
            currency: 'EUR',
            value: 0,
            lead_source: 'demo_request'
          });
        }
      } else {
        setIsSubmitting(false);
        setSubmitError(en ? 'Sending failed. Please try again or contact us directly.' : ru ? 'Отправка не удалась. Пожалуйста, попробуйте еще раз или свяжитесь с нами напрямую.' : 'Slanje nije uspelo. Pokušajte ponovo ili nas kontaktirajte direktno.');
      }
    } catch (err) {
      setIsSubmitting(false);
      setSubmitError(en ? 'Network error. Please try again or contact us directly.' : ru ? 'Ошибка сети. Пожалуйста, попробуйте еще раз или свяжитесь с нами напрямую.' : 'Greška u mreži. Pokušajte ponovo ili nas kontaktirajte direktno.');
    }
  };
  if (submitSuccess) {
    return <div className="text-center py-8" data-id="element-33">
        <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-34">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-35">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-36" />
          </svg>
        </div>
        <h3 className="text-2xl font-bold text-white mb-2" data-id="element-37">
          {en ? 'Successfully sent!' : ru ? 'Успешно отправлено!' : 'Uspešno poslato!'}
        </h3>
        <p className="text-gray-300 mb-4" data-id="element-38">
          {en ? 'Our team will contact you as soon as possible to confirm the demonstration time.' : ru ? 'Наша команда свяжется с вами в ближайшее время, чтобы подтвердить время демонстрации.' : 'Naš tim će vas kontaktirati u najkraćem roku da potvrdi termin demonstracije.'}
        </p>
        {onSuccess && <Button variant="primary" size="md" onClick={onSuccess} className="mt-6" data-id="element-39">
            {en ? 'Close' : ru ? 'Закрыть' : 'Zatvori'}
          </Button>}
      </div>;
  }
  const minDate = new Date();
  minDate.setDate(minDate.getDate() + 5);
  const minDateString = minDate.toISOString().split('T')[0];
  return <form onSubmit={handleSubmit} className="space-y-6" noValidate data-id="element-40">
      <div className="bg-brand-yellow bg-opacity-10 border-2 border-brand-yellow rounded-industrial p-4 mb-6" data-id="element-41">
        <p className="text-sm text-brand-yellow font-semibold" data-id="element-42">
          {en ? 'Demonstration requests must be submitted at least 5 days in advance.' : ru ? 'Заявки на демонстрацию должны быть поданы не менее чем за 5 дней.' : 'Zahtevi za demonstraciju moraju biti podneseni najmanje 5 dana unapred.'}
        </p>
      </div>

      <Input label={en ? 'Full name *' : ru ? 'Полное имя *' : 'Ime i prezime *'} type="text" name="Ime_i_prezime" required placeholder={en ? 'Your full name' : ru ? 'Ваше полное имя' : 'Vaše ime i prezime'} data-id="element-43" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-44">
        <Input label={en ? 'Email *' : 'Email *'} type="email" name="email" required placeholder={en ? 'your@email.com' : ru ? 'vas.email@primer.com' : 'vas.email@primer.com'} data-id="element-45" />
        <Input label={en ? 'Phone *' : ru ? 'Телефон *' : 'Telefon *'} type="tel" name="Telefon" required placeholder={en ? '+1 ...' : ru ? '+7 ...' : '+381 60 123 4567'} data-id="element-46" />
      </div>

      <Input label={en ? 'City *' : ru ? 'Город *' : 'Grad *'} type="text" name="Grad" required placeholder={en ? 'Your city' : ru ? 'Ваш город' : 'Vaš grad'} data-id="element-47" />

      <Input label={en ? 'Full address *' : ru ? 'Полный адрес *' : 'Puna adresa *'} type="text" name="Puna_adresa" required placeholder={en ? 'Street, number, postal code' : ru ? 'Улица, номер, почтовый индекс' : 'Ulica, broj, poštanski broj'} data-id="element-48" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-49">
        <Input label={en ? 'Preferred date *' : ru ? 'Желаемая дата *' : 'Željeni datum *'} type="date" name="Zeljeni_datum" min={minDateString} required data-id="element-50" />
        <Select label={en ? 'Time window *' : ru ? 'Временное окно *' : 'Vremenski period *'} name="Vremenski_period" required options={[{
        value: '',
        label: en ? 'Select time window' : ru ? 'Выберите временное окно' : 'Izaberite vremenski period'
      }, {
        value: '09:00-12:00',
        label: '09:00 - 12:00'
      }, {
        value: '12:00-15:00',
        label: '12:00 - 15:00'
      }, {
        value: '15:00-18:00',
        label: '15:00 - 18:00'
      }]} data-id="element-51" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-52">
        <Input label={en ? 'Load type (optional)' : ru ? 'Тип груза (необязательно)' : 'Tip tereta (opciono)'} type="text" name="Tip_tereta" placeholder={en ? 'e.g. boxes, equipment' : ru ? 'напр. коробки, оборудование' : 'npr. kutije, oprema'} data-id="element-53" />
        <Input label={en ? 'Estimated weight (optional)' : ru ? 'Расчетный вес (необязательно)' : 'Procenjena težina (opciono)'} type="text" name="Procenjena_tezina" placeholder={en ? 'e.g. 150 kg' : ru ? 'напр. 150 кг' : 'npr. 150 kg'} data-id="element-54" />
      </div>

      <Textarea label={en ? 'Notes (optional)' : ru ? 'Примечания (необязательно)' : 'Napomene (opciono)'} name="Napomene" placeholder={en ? 'Special requests or questions' : ru ? 'Особые запросы или вопросы' : 'Posebni zahtevi ili pitanja'} rows={4} data-id="element-55" />

      {submitError && <div className="p-4 bg-red-500/10 border-2 border-red-500/50 rounded-industrial text-sm text-red-300" data-id="element-56">
          {submitError}
        </div>}

      <Button type="submit" variant="primary" size="lg" disabled={isSubmitting} className="w-full" data-id="element-57">
        {isSubmitting ? en ? 'Sending...' : ru ? 'Отправка...' : 'Šaljem...' : en ? 'Request demonstration' : ru ? 'Запросить демонстрацию' : 'Zatražite demonstraciju'}
      </Button>
    </form>;
}